<div class="tempoRastro">
  <div>
    <h3>{{ 'COMPONENTS.MAPA.DIALOGS.TRACK_TIMES.title' | transloco }}</h3>
    <div class="progress-container">
      <div class="progress-bar-wrapper">
        <app-loading style="margin-top: 1rem;" *ngIf="carregandoRastros" [height]="1.7" [colunas]="1" [linhas]="1" cor="#e6e4e4"></app-loading>

        <div class="progress-segments" *ngIf="!carregandoRastros">
          @for (tempoRastro of temposRastros; track tempoRastro.tipo) {
          <div class="segment" [style.width.%]="tempoRastro.porcentagem" [style]="'--cor-rastro:' + coresRastros[tempoRastro.tipo]" [matTooltip]="tempoRastro.porcentagem + '% (' + tempoRastro.duracao + ')'" matTooltipPosition="above">
            <span [hidden]="tempoRastro.porcentagem / 100 * 368 < 11 * tempoRastro.duracao.length"> {{ tempoRastro.porcentagem }}% ({{ tempoRastro.duracao }})</span>
          </div>
          }
        </div>
      </div>

      <div class="legenda">
        <div class="coluna">
          <div class="item">
            <span class="cor plantando"></span>
            <span class="texto">
              {{ 'COMPONENTS.MAPA.DIALOGS.TRACK_TIMES.planting' | transloco }}
            </span>
          </div>

          <div class="item">
            <span class="cor deslocando"></span>
            <span class="texto">
              {{ 'COMPONENTS.MAPA.DIALOGS.TRACK_TIMES.displacement' | transloco }}
            </span>
          </div>
        </div>

        <div class="coluna">
          <div class="item">
            <span class="cor manobrando"></span>
            <span class="texto">
              {{ 'COMPONENTS.MAPA.DIALOGS.TRACK_TIMES.maneuvering' | transloco }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
